import { apiClient } from './client';

// ── Categories ──────────────────────────────────────────────────────────────

export async function getCategories() {
  const res = await apiClient.get('/calendar/categories');
  const d = res.data;
  return Array.isArray(d) ? d : d?.items ?? [];
}

export async function createCategory(body) {
  const res = await apiClient.post('/calendar/categories', body);
  return res.data;
}

export async function updateCategory(id, body) {
  const res = await apiClient.put(`/calendar/categories/${id}`, body);
  return res.data;
}

export async function deleteCategory(id) {
  await apiClient.delete(`/calendar/categories/${id}`);
}

// ── Events ───────────────────────────────────────────────────────────────────

export async function getEvents(params = {}) {
  const res = await apiClient.get('/calendar/events', { params });
  const d = res.data;
  return Array.isArray(d) ? d : d?.items ?? [];
}

export async function getEvent(id) {
  const res = await apiClient.get(`/calendar/events/${id}`);
  return res.data;
}

export async function createEvent(body) {
  const res = await apiClient.post('/calendar/events', body);
  return res.data;
}

export async function updateEvent(id, body) {
  const res = await apiClient.put(`/calendar/events/${id}`, body);
  return res.data;
}

export async function deleteEvent(id) {
  await apiClient.delete(`/calendar/events/${id}`);
}
